import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import DownSidePanel from "./downSidePanel";
import { getActiveDocumentId } from "./redux/selectors";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { getStatisticData } from "Areas/Documents/graph/redux/selectors";
import { getTimelineData as getMapTimelineData } from "Areas/Documents/map/redux/selectors";
import { getActiveDocumentType } from "Areas/Sidebar/Documents/redux/selectors";
import { TAB } from "./constants";
const canViewTasksLogs = security.isAllowed([Permissions.TasksView]);
const statisticOrTimelineDataMap = {
    [DOCUMENT_TYPE.GRAPH]: (state) => getStatisticData(state),
    [DOCUMENT_TYPE.MAP]: (state) => getMapTimelineData(state)
};
const downSidePanelDisabledTabsMap = {
    [DOCUMENT_TYPE.GRAPH]: [TAB.TIMELINE],
    [DOCUMENT_TYPE.TABLE]: [TAB.TIMELINE, TAB.PRESENTATION],
    [DOCUMENT_TYPE.MAP]: [TAB.PRESENTATION],
    [DOCUMENT_TYPE.CONTENT]: [TAB.TIMELINE, TAB.PRESENTATION]
};
const mapStateToProps = (state) => {
    const activeDocumentType = getActiveDocumentType(state);
    const getStatisticOrTimelineData = activeDocumentType
        ? statisticOrTimelineDataMap[activeDocumentType]
        : undefined;
    const disabledTabs = activeDocumentType
        ? downSidePanelDisabledTabsMap[activeDocumentType]
        : undefined;
    return {
        statisticData: getStatisticOrTimelineData === null || getStatisticOrTimelineData === void 0 ? void 0 : getStatisticOrTimelineData(state),
        key: getActiveDocumentId(state) || "",
        canViewTasksLogs,
        disabledTabs
    };
};
export default connect(mapStateToProps)(DownSidePanel);
